import { Component, OnInit } from '@angular/core';
import { CourseService } from '../../services/course.service';
import { Course, CourseStatus } from '../../models/course.model';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage.service';
import { ErrorHandlingService } from '../../services/error-handling.service';

@Component({
  selector: 'app-course-list',
  templateUrl: './course-list.component.html',
  styleUrls: ['./course-list.component.css']
})
export class CourseListComponent implements OnInit {
  courses: Course[] = [];
  loading = false;
  isTeacher = false;
  isAdmin = false;
  filterStatus: string = '';

  constructor(
    private courseService: CourseService,
    private router: Router,
    private tokenStorage: LocalStorageService,
    private errorHandling: ErrorHandlingService
  ) {
    this.isTeacher = this.tokenStorage.isTeacher();
    this.isAdmin = this.tokenStorage.isAdmin();
  }

  ngOnInit(): void {
    this.loadCourses();
  }

  loadCourses(): void {
    this.loading = true;
    const teacherId = this.isTeacher ? this.getCurrentUserId() : undefined;

    this.courseService.getCourses(teacherId, this.filterStatus).subscribe({
      next: (data) => {
        this.courses = data;
        this.loading = false;
      },
      error: (error) => {
        this.errorHandling.handleError(error);
        this.loading = false;
      }
    });
  }

  viewCourse(id: number): void {
    this.router.navigate(['/courses', id]);
  }

  createCourse(): void {
    this.router.navigate(['/courses/new']);
  }

  editCourse(id: number): void {
    this.router.navigate(['/courses', id, 'edit']);
  }

  deleteCourse(id: number): void {
    if (confirm('Are you sure you want to delete this course?')) {
      this.courseService.deleteCourse(id).subscribe({
        next: () => {
          this.errorHandling.showSuccess('Course deleted successfully');
          this.loadCourses();
        },
        error: (error) => this.errorHandling.handleError(error)
      });
    }
  }

  getStatusClass(status: string): string {
    switch (status) {
      case CourseStatus.ACTIVE:
        return 'status-active';
      case CourseStatus.COMPLETED:
        return 'status-completed';
      case CourseStatus.DRAFT:
        return 'status-draft';
      case CourseStatus.CANCELLED:
        return 'status-cancelled';
      default:
        return '';
    }
  }

  private getCurrentUserId(): number {
    // TODO: Get from token or user service
    return 0;
  }
}
